export const ConsumerPhoneValidationErrorGeneralStyle = {
  container: 'w-full flex justify-center mt-3',
  banner: 'text-red100 flex justify-center py-4 max-w-xs',
}
